export async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const replaceSeparator = (str, separator = '&', replacement = ', ', lastReplacement = ' and ') => {
  const regex = new RegExp(separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'); // escape special characters
  const matches = str.match(regex);
  if (!matches || matches.length === 0) return str;

  const lastIndex = str.lastIndexOf(separator);

  return str.replace(regex, (match, offset) => (offset === lastIndex ? lastReplacement : replacement));
};

export function maskMiddleWithThreeAsterisks(str) {
  if (!str || typeof str !== 'string' || str.length <= 2) return str;

  const firstChar = str.charAt(0);
  const lastChar = str.charAt(str.length - 1);

  return firstChar + '***' + lastChar;
}

export const convertLabelPodMethods = (field) => {
  let f = String(field);
  if (field === 'order_number') {
    f = 'purchase_order_number';
  }
  if (field === 'internal_id') {
    f = 'order_number';
  }
  return f
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Client settings arrive as boolean true or string 'true' depending on source
export const isSettingEnabled = (value) => value === true || value === 'true';
